import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgForm, FormControl } from '@angular/forms';

import { LoginData } from '../../interfaces/index';
import { AuthService } from '../../api/auth.api';

@Component({
  selector: 'school-login-ui',
  templateUrl: './login-ui.component.html',
  styleUrls: ['./login-ui.component.scss'],
})
export class LoginuiComponent implements OnInit {

  @Input() usertype: any;
  @Input() forgotpasswordlink: any;
  @Input() factorverificationlink: any;
  @Input() dashboardLink: string;
  @Input() signupLink: string;

  private loginData: LoginData;
  public error: string;
  isLoading: boolean;
  pwdhide = true;

  constructor(private route: Router, private _route: ActivatedRoute, private authService: AuthService) {
    this.isLoading = false;
  }

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('extDis')) {
        localStorage.setItem('extDis' + this.usertype, params.extDis);
      }
      if (params.hasOwnProperty('extDisX')) {
        localStorage.setItem('extDisX' + this.usertype, params.extDisX);
      }
      if (params.hasOwnProperty('extDisY')) {
        localStorage.setItem('extDisY' + this.usertype, params.extDisY);
      }
    })

  }

  onSubmit(form: NgForm) {
    this.loginData = {
      username: form.value.username,
      password: form.value.password,
      role: this.usertype,
    }

    this.error = '';
    this.isLoading = true;

    this.authService.login(this.loginData).subscribe(resData => {
      if (resData.body.data.status == "verified_user") {
        this.isLoading = false;
        this.route.navigate([this.dashboardLink]);
      } else if (resData.body.data.status == 'OTP_SENT') {
        this.factorverification(this.loginData);
      }
    },
      error => {
        this.error = error;
        this.isLoading = false;
      });
  }

  forgotpassword() {
    this.route.navigate([`/${this.forgotpasswordlink}`]);
  }

  signup() {
    this.route.navigate([`/${this.signupLink}`]);
  }

  factorverification(data) {

    const navigationExtras: NavigationExtras = {
      state: {
        username: data.username,
        password: data.password
      }
    };
    this.route.navigate([`/${this.factorverificationlink}`], navigationExtras);
  }

}
